import { IFormRichTextEditor } from 'cng-common/features/form/components/formRichTextEditor/models'
import { OnboardingFormRichTextEditor } from 'onboarding/components/ui/theme'

import { TAdaptingDisabled } from './types'

export const OnboardingFormRichTextEditorAdapter = ({
  disabled,
  isDisabled,
  ...props
}: IFormRichTextEditor & TAdaptingDisabled) => (
  <OnboardingFormRichTextEditor {...props} isDisabled={isDisabled || disabled} />
)
